<template>
    <div class="rr-shopping-cart-resume">
        <div class="rr-shopping-cart-resume__header uk-flex uk-flex-between uk-flex-middle">
            <p class="rr-shopping-cart-resume__title uk-h4">
                {{ $t('rubinred.ecommerce.orders.checkout.sidebar.title') }}
            </p>
            <a :href="cartEndpoint" class="uk-link-muted">{{ $t('rubinred.ecommerce.orders.checkout.sidebar.modify') }}</a>
        </div>
        <ul class="rr-shopping-cart-resume__product-list uk-list">
            <li class="rr-shopping-cart-resume__product" v-for="item in cart.items">
                <span class="rr-shopping-cart-resume__product-quantity">{{ item.quantity }}</span>
                <span class="rr-shopping-cart-resume__product-name">{{ item.name }}</span>
                <span class="rr-shopping-cart-resume__product-price">{{ Utils.Currencies.toHuman(item.total) }}</span>
            </li>
        </ul>
        <ul class="rr-shopping-cart-resume__totals-list uk-list">
            <li>
                <div class="uk-flex uk-flex-middle uk-flex-between">
                    <span>{{ $t('rubinred.ecommerce.orders.common.subtotal') }}</span>
                    <strong>{{ Utils.Currencies.toHuman(cart.subtotal) }}</strong>
                </div>
            </li>
            <li>
                <div class="uk-flex uk-flex-middle uk-flex-between">
                    <span>{{ $t('rubinred.ecommerce.orders.common.shipping') }}</span>
                    <strong>{{ Utils.Currencies.toHuman(cart.shipping_total) }}</strong>
                </div>
            </li>
            <li v-if="cart.payment_total > 0">
                <div class="uk-flex uk-flex-middle uk-flex-between">
                    <span>{{ $t('rubinred.ecommerce.orders.common.payment') }}</span>
                    <strong>{{ Utils.Currencies.toHuman(cart.payment_total) }}</strong>
                </div>
            </li>
            <li v-if="cart.discount_total < 0">
                <div class="uk-flex uk-flex-middle uk-flex-between">
                    <span>{{ $t('rubinred.ecommerce.orders.common.discount') }}</span>
                    <strong>{{ Utils.Currencies.toHuman(cart.discount_total) }}</strong>
                </div>
            </li>
        </ul>
        <div class="rr-shopping-cart-resume__total uk-flex uk-flex-middle uk-flex-between">
            <strong>{{ $t('rubinred.ecommerce.orders.common.order_total') }}</strong>
            <strong>{{ Utils.Currencies.toHuman(cart.total) }}</strong>
        </div>
    </div>
</template>

<script>
  import CartAwareComponent from 'rubinred/ecommerce/js/mixins/CartAwareComponent'

  export default {
    mixins: [CartAwareComponent],
    props: {
      cartEndpoint: {
        type: String,
        required: true,
      },
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/partials/RubinredCheckoutResume.vue